module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "config-form-wrapper row"
  }, [_c('div', {
    staticClass: "config-form col-md-6 col-lg-5 col-xl-4"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('br'), (_vm.hasColumns) ? _c('SmartForm', {
    attrs: {
      "formList": _vm.formList,
      "formLabelWidth": 160,
      "columns": _vm.columns,
      "values": _vm.formValues
    }
  }) : _vm._e()], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53bb0d36","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/System/Config.vue
// module id = 1753
// module chunks = 1